<script>
	import {onDestroy, onMount} from 'svelte';
    import {fade} from 'svelte/transition';
    import {PRConnect} from "@projectroom/ui-lib";
    import { navigateTo } from 'svelte-router-spa';
	import { _ } from 'svelte-i18n';
	import Select from 'svelte-select';
	import intlTelInput from 'intl-tel-input';
	import { accessToken } from './store/auth-store';
	import { Card, Button, Dialog } from '../lib/ui';

    let refPhoneNo;
    let refMessageToken;
    let refAgreement;
    let phoneNo;
    let messageToken;
    let messageTokenFlag = false;
    let phoneSubmitFlag = true;
	let agreePrivacyFlag = false;
    let errorMesage = "";
    let phoneBorder = false;
    let messageTokenBorder = false;
    let reSubmitTime = 60;
    let showSubmitTime = "1:00";
	let isErrorPopup;
	let errorType;
	let fieldList = [];
	let refFieldList;
	let refField;
	let countrySelect;

	const countryCodes = [{ value: 'KR', label: '한국 (+82)' },
    { value: 'US', label: 'United States (+1)' },
    { value: 'JP', label: '日本 (+81)' }];
	let countryCode = 'KR';

	// shadcn 인풋 공용 클래스
	const inputCls = "tw-flex tw-h-11 tw-w-full tw-rounded-md tw-border tw-border-input tw-bg-background tw-px-3 tw-py-2 tw-text-sm tw-text-foreground placeholder:tw-text-muted-foreground focus:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-ring disabled:tw-opacity-50";
	const errStyle = "border-color:hsl(var(--sb-destructive))";

	// 관심 분야 선택지(103~114 i18n 키)
	const interestKeys = [
		'project.default.103', 'project.default.104', 'project.default.105', 'project.default.106',
		'project.default.107', 'project.default.108', 'project.default.109', 'project.default.110',
		'project.default.111', 'project.default.112', 'project.default.113', 'project.default.114',
	];

	onMount( () => {
		const input = document.querySelector(".phone-number");
		countrySelect = intlTelInput(input, {
				initialCountry: "auto",
				utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@20.0.3/build/js/utils.js",
				geoIpLookup: callback => {
					fetch("https://ipapi.co/json")
					.then(res => res.json())
					.then(data => callback(data.country_code))
					.catch(() =>callback("ko"));
				}
		});
		console.log(countrySelect);
	});

    const validPhoneNo = () => {
        // 전화번호 유효성체크, 우선 길이정도
        if (refPhoneNo.value.length >= 10) {
            errorMesage = undefined;
            return false;
        }
        return true;
    }

    const validMessageToken = () => {
        // 메세지토큰 유효성체크, 우선 길이정도
        if (refMessageToken.value.length === 6) {
            errorMesage = undefined;
            return false;
        }
        return true;
    }
    const clickPhoneNoSubmit = () => {
        if (validPhoneNo()) {
            errorMesage= $_('project.default.89_JoinAttenstation');
            return;
        }
        refPhoneNo.readOnly = true;
        messageTokenFlag = true;
		countryCode = countrySelect.getSelectedCountryData().iso2.toUpperCase();
		const phoneNo = refPhoneNo.value.replace(/-/g, "");
        const authToken = window.location.search.substr(1, 32);
        PRConnect.send("/api/Auth/messageTokenPublish", {phoneNo, authToken, countryCode}, data => {
            if (data.header.status === "success") {
                if (data.result.status === "error") {
                    navigateTo("/login");
                    return;
                }
                console.log("messageTokenPublish success");
                makeReSubmit();
            }
        });
    }

    const makeReSubmit = () => {
        messageTokenFlag = true;
        phoneSubmitFlag = false;
        const interval = setInterval(() => {
            try {
                if (reSubmitTime < 1) {
                phoneSubmitFlag=true;
                refPhoneNo.readOnly=false;
                reSubmitTime=60;
                showSubmitTime=`0:${reSubmitTime}`;
                clearInterval(interval);
                }
                --reSubmitTime;
                if (reSubmitTime < 10) {
                    showSubmitTime=`0:0${reSubmitTime}`;
                } else {
                    showSubmitTime=`0:${reSubmitTime}`;
                }
            } catch(error) {
                console.log("makeReSubmit fail : ", error);
                clearInterval(interval);
            }
        }, 1000);
    }

    const clickJoinSubmit = () => {
        if (validPhoneNo()) {
            errorMesage= $_('project.default.89_JoinAttenstation');
			refPhoneNo.focus();
            return;
        }
        if (!messageTokenFlag) {
            errorMesage= $_('project.default.90');
            return;
        }
        if (validMessageToken()) {
            errorMesage = $_('project.default.91');
			refMessageToken.focus();
            return;
        }

		if (!agreePrivacyFlag) {
			errorMesage = $_('project.default.71');
			return;
		}
		if (refField.value.length == 0) {
			errorMesage = $_('project.default.101_1');
			refField.focus();
			return;
		}

        const authToken = window.location.search.substr(1, 32);
        PRConnect.send("/api/Auth/phoneAuth", {phoneNo:refPhoneNo.value, authToken, messageToken:refMessageToken.value, countryCode, interests : refField.value}, data => {
            if (data.header.status === "success") {
                if (data.result.status === "success") {
					accessToken.set(data.result.accessToken);
					navigateTo("/main");
                } else {
                    errorMesage = data.result.message;
                    messageTokenBorder = true;
                }
            }
		}, error => {
			isErrorPopup = true
			errorType = error.header.code;
			errorMesage = error.header.message;
		});
    }

    const changePhoneNo = () => {
		phoneBorder = validPhoneNo();
    }

    const changeMessageToken = () => {
        messageTokenBorder = validMessageToken();
    }

	const changeCountryCode = (event) => {
		countryCode = event.detail.value;
	}

	const toggleField = (label) => {
		if (fieldList.includes(label)) {
			fieldList = fieldList.filter(element => element !== label);
		} else {
			fieldList = [...fieldList, label];
		}
		refFieldList = fieldList.join(',');
	}
</script>

<div class="tw-flex tw-min-h-screen tw-justify-center tw-bg-background tw-px-4 tw-pb-20 tw-pt-24 tw-font-sans tw-text-foreground sm:tw-pt-28" in:fade id="join-attestation">
    <div class="tw-w-full tw-max-w-[420px]">
        <Card class="tw-p-8 sm:tw-p-10">
            <h1 class="tw-mb-1 tw-text-center tw-text-2xl tw-font-bold tw-text-foreground">{$_('project.default.92')}</h1>

            {#if errorMesage}
                <div class="tw-mt-4 tw-rounded-md tw-bg-destructive/10 tw-px-3 tw-py-2 tw-text-center tw-text-sm tw-font-medium tw-text-destructive">{errorMesage}</div>
            {/if}

            <form class="tw-mt-6 tw-space-y-4" on:submit|preventDefault={clickJoinSubmit}>
                <div>
                    <label for="ja-phone" class="tw-mb-1.5 tw-block tw-text-sm tw-font-medium tw-text-foreground">{$_('project.default.93')}</label>
                    <div class="phone-row tw-flex tw-gap-2">
                        <input id="ja-phone" type="tel" bind:this={refPhoneNo} class="{inputCls} phone-number" placeholder={$_('project.default.94')} style={phoneBorder ? errStyle : ""} />
                        {#if phoneSubmitFlag}
                            <Button type="button" variant="secondary" class="tw-h-11 tw-shrink-0" on:click={clickPhoneNoSubmit}>{$_('project.default.95')}</Button>
                        {:else}
                            <Button type="button" variant="secondary" disabled class="tw-h-11 tw-shrink-0 tw-tabular-nums">{showSubmitTime}</Button>
                        {/if}
                    </div>
                </div>

                {#if messageTokenFlag}
                    <div>
                        <input type="number" bind:this={refMessageToken} maxlength="6" placeholder={$_('project.default.96')} on:change={changeMessageToken} class={inputCls} style={messageTokenBorder ? errStyle : ""} />
                    </div>
                {/if}

                <label class="tw-flex tw-cursor-pointer tw-items-center tw-gap-2.5 tw-py-1">
                    <input type="checkbox" bind:checked={agreePrivacyFlag} class="tw-h-4 tw-w-4 tw-shrink-0 tw-cursor-pointer tw-accent-primary" />
                    <span class="tw-text-sm tw-text-muted-foreground">{$_('project.default.91_1')}</span>
                </label>

                <div class="tw-pt-1">
                    <label for="ja-interests" class="tw-mb-1.5 tw-block tw-text-sm tw-font-semibold tw-text-foreground">{$_('project.default.101')}</label>
                    <input id="ja-interests" bind:this={refField} bind:value={refFieldList} readonly class="{inputCls} tw-cursor-default tw-bg-muted/40" placeholder={$_('project.default.102')} />
                    <div class="tw-mt-2.5 tw-flex tw-flex-wrap tw-gap-2">
                        {#each interestKeys as key}
                            <button
                                type="button"
                                on:click={() => toggleField($_(key))}
                                class={"tw-cursor-pointer tw-rounded-full tw-border tw-px-3 tw-py-1.5 tw-text-xs tw-font-medium tw-transition-colors " + (fieldList.includes($_(key)) ? "tw-border-primary tw-bg-primary tw-text-primary-foreground" : "tw-border-border tw-bg-background tw-text-muted-foreground hover:tw-bg-muted")}
                            >{$_(key)}</button>
                        {/each}
                    </div>
                </div>

                <Button type="submit" size="lg" class="tw-w-full">{$_('project.default.97')}</Button>
            </form>
        </Card>
    </div>
</div>

<Dialog open={isErrorPopup} on:close={()=> navigateTo("main")}>
    <div class="tw-text-center">
        {#if errorType === "IS_PHONE_NUMBER_DUPLICATED"}
            <div class="tw-text-lg tw-font-bold tw-text-primary">{$_('project.default.98')}</div>
            <div class="tw-mt-1.5 tw-text-sm tw-text-muted-foreground">{$_('project.default.99')}</div>
        {:else if errorType === "IS_PHONE_NUMBER_LIMITED"}
            <div class="tw-text-sm tw-text-foreground">{errorMesage}</div>
        {/if}
    </div>
    <Button slot="footer" on:click={()=> navigateTo("main")}>{$_('project.default.100')}</Button>
</Dialog>

<style>
	/* intl-tel-input이 마운트 시 phone-number 인풋을 .iti로 감싼다 → flex 행에서 늘어나게 */
	.phone-row :global(.iti) {
		flex: 1 1 auto;
		min-width: 0;
	}
	.phone-row :global(.phone-number) {
		width: 100%;
	}
</style>
